import React, { useState, useEffect } from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { STORAGE_KEYS, ROUTES } from './constants.js';

import { GeneralContextProvider } from './components/GeneralContext.js';
import SideBar from './components/Sidebar';
import Home from './pages/Home';
import Character from './pages/Character';
import Placeholder from './pages/Placeholder';
import Rules from './pages/Rules';
import theme from './theme';

function App() {
  const [indexes, setIndexes] = useState([]);

  const parseIndexes = () => {
    const indexes =
      JSON.parse(localStorage.getItem(STORAGE_KEYS.CHARACTER_INDEXES)) ?? [];
    setIndexes(indexes);
  };

  useEffect(() => {
    parseIndexes();
  }, []);

  useEffect(() => {}, [indexes]);

  return (
    <ChakraProvider theme={theme}>
      <GeneralContextProvider onCharIndexChanged={parseIndexes}>
        <BrowserRouter>
          <Box display="flex">
            <SideBar height="100vh" />
            <Box flex="1" p="4">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/placeholder" element={<Placeholder />} />
                <Route path="/rules" element={<Rules />} />
                <Route path={ROUTES.CHARACTER} element={<Character />} />
                {indexes.map(index => (
                  <Route
                    key={index}
                    path={index}
                    element={<Character index={index} />}
                  />
                ))}
              </Routes>
            </Box>
          </Box>
        </BrowserRouter>
      </GeneralContextProvider>
    </ChakraProvider>
  );
}

export default App;
